import React from 'react';
import { Typography } from 'antd';
const { Text } = Typography;
//контент для всплывающей подсказки старотовой секции
export const startSectionContentPopover = (
  <div>
    Для добавления одного ТС доступно<br></br>
    ОДНО автоматическое определение<br></br>
    данных ТС по рег. знаку.<br></br>
  </div>
);
// вторая секция
export const diagnosticCardPopupContent = (
  <div>
    При организованной перевозке групп детей автобусами
    <br />
    данные о диагностической карте(номер и срок действия)
    <br />
    автоматически передаются в подразделение <br />
    Госавтоинспекции в составе Уведомления.
  </div>
);

export const countDoorPopupContent = (
  <div>
    Количество дверей в транспортном средстве <br />
    указывается для определения количества
    <br /> сопровождающих на 1 автобус назначается
    <br /> из расчета их нахождения у каждой
    <br /> двери автобуса (утверждено постановлением
    <br /> Правительства РФ от 17.12.2013 N 1177
    <br />
    «Об утверждении Правил организованной
    <br /> перевозки группы детей автобусами»).
  </div>
);

export const destinationPopupHeader = (
  <div>
    <h3>Назначение ТС</h3>
    <Text>Виды назначения ТС</Text>
  </div>
);

export const destinationPopupContent = (
  <div className="content">
    <strong>Городские (низкопольные)</strong> — автобусы, предназначенные для
    использования в качестве городского (в том числе маршрутного) пассажирского
    транспорта
    <br />
    <strong>Междугородные</strong>— автобусы, предназначенные для перевозки
    людей на дальние расстояния. Имеют обычно большие багажные отделения. Но не
    имеют место для гида
    <br />
    <strong>Туристические</strong> — междугородные автобусы, предназначенные для
    поездок организованных групп по произвольным маршрутам. От междугородных
    отличаются, как правило, повышенным уровнем комфорта и наличием места гида,
    оборудованного микрофоном для проведения экскурсий
    <br />
    <strong>Пригородные</strong> — в отличие от междугородних не предназначены
    для перевозок на дальние расстояния. Такие автобусы обычно не имеют багажных
    отделений, но имеют места для ручной клади. В них обычно отсутствуют
    накопительные площадки, но могут присутствовать поручни для стоящих
    пассажиров. Но основной способ проезда пассажиров в них все же — сидя в
    пассажирских креслах
    <br />
    <strong>Перронные (аэродромные)</strong> — предназначены для доставки
    пассажиров от аэровокзала к самолётам и от самолётов к аэровокзалу
    <br />
    <strong>Школьные</strong> — автобусы, предназначенные для перевозки
    организованных групп детей и имеющие специальные цвета окраски
    <br />
    <strong>Экскурсионные</strong> — предназначенные для экскурсионных поездок
    <br />
    <strong>Вахтовые (экспедиционные)</strong> — предназначенные для перевозки
    рабочих к местам проведения строительных, ремонтных и прочих работ.
    Технически это могут быть самые разнообразные пассажирские автотранспортные
    средства, но довольно часто такие автобусы строятся на грузовой базе. То
    есть вместо грузового кузова (фургона) на шасси грузовой машины
    устанавливается пассажирский салон
    <br />
    <strong>Вездеходы</strong> — для перевозки людей при сложных дорожных
    условиях (в том числе по бездорожью)
    <br />
    <strong>Грузовые (грузопассажирские)</strong> — <br />
    <strong>Почтовые (автобусы связи)</strong> — для перевозки почты
    <br />
    <strong>Ритуальные</strong> — предназначенные для перевозки умершего и/или
    похоронной процессии к месту погребения (или ритуальной кремации) усопшего
    <br />
    <strong>Тюремные (автозаки)</strong> — предназначенные для перевозки
    заключенных и военнопленных в места лишения свободы. В отличие от обычных,
    такие автобусы с полной шумоизоляцией, бронированные дверцы и отсутствие
    окон; Найт/пати/клубные - автобусы, предназначенные для развлекательных
    мероприятий (вечеринки, дни рождения, выпускной, свадьбы и т.д.).
    <br />
  </div>
);

// секция четвертая
export const licFromAccountPopupContent = (
  <div className="wrapContentforlicFrom">
    Согласно положения о лицензировании деятельности по перевозкам пассажиров и
    иных лиц автобусами (утверждено постановлением Правительства Российской
    Федерации от 27 февраля 2019 г. N 195) - перевозчик обязан использовать
    автобусы, включеные в государственный реестр лицензий на лицензируемую
    деятельность по перевозкам пассажиров и иных лиц автобусами. «Автобус
    лицензиата» - транспортное средство категории M2 или M3, принадлежащее
    лицензиату на праве собственности или ином законном основании (за
    исключением аренды транспортных средств с экипажем), сведения о котором
    внесены в реестр лицензий на осуществление лицензируемого вида деятельности
    (далее - лицензия на лицензируемую деятельность), и используемое лицензиатом
    для осуществления лицензируемого вида деятельности. Система Teleportos
    всегда формирует путевой лист с указанием перевозчика - лицензиата ТС.
  </div>
);
export const ownerFromAccountPopupContent = (
  <div>
    От данного лица система Teleportos
    <br /> формирует путевой лист при
    <br />
    использовании этого ТС
  </div>
);
// шестая секция
export const attachedDriversPopup = (
  <div className="attachedDriversPopup">
    Будут отображаться первыми в списке
    <br />
    при назначении на заказ
    <br /> данного транспортного средства.
    <br />
    У выбранных водителей транспортное средство
    <br /> будет отображаться в приложении
    <br /> <strong>«Teleportos для водителей»</strong>
  </div>
);
// седьмая секция
export const restrictionPopupContent = (
  <div>
    На выбранные услуги вы не сможете назначить
    <br /> данное транспортное средство.
  </div>
);

export const excludedPopupContent = (
  <div>
    Выбранные водители не смогут быть назначены
    <br /> на заказ с данным транспортным средством.
  </div>
);
